import type {
  ActionFactory,
  Context,
  EditActionDefinition,
  EditActionsDictionary,
  HostEditActionDefinition,
  HostEditAction,
  ActionNames,
  NativeActionContext,
  PlatformApiMethods,
} from '@wix/editor-platform-host-integration-apis';
import { Action, DashboardAction } from '@wix/component-protocol/schema';
import { ComponentsService } from '@wix/editor-platform-manifest-services';

type CustomizedNativeManifestAction = Required<Action>;

type CustomizedDashboardManifestAction = Omit<
  Required<DashboardAction>,
  'dashboardPageId'
> & { dashboardPageId?: string };

type CustomManifestAction = Required<Action>;

type CustomEditActionsDictionary<TAction extends Action> = Record<
  string,
  TAction
>;

const isCustomManifestAction = (
  action: CustomManifestAction | Action,
): action is CustomManifestAction => {
  return 'execution' in action;
};

type PlatformContext = Context<ComponentsService, PlatformApiMethods>;

type ExtendedPlatformContext = PlatformContext &
  Omit<NativeActionContext, 'contextAPI'>;

type ActionFactoryWithPlatformContext = ActionFactory<
  ExtendedPlatformContext,
  EditActionDefinition | HostEditActionDefinition
>;

type PlatformEditAction =
  | HostEditActionDefinition
  | ActionFactoryWithPlatformContext;

type EditAction = HostEditAction | PlatformEditAction;

type ContributedPlatformActionsDict = EditActionsDictionary<PlatformEditAction>;

type ContributedEditActionsDict = EditActionsDictionary<EditAction>;

export {
  CustomizedNativeManifestAction,
  CustomizedDashboardManifestAction,
  CustomManifestAction,
  ActionNames,
  EditActionsDictionary,
  CustomEditActionsDictionary,
  PlatformEditAction,
  PlatformContext,
  ExtendedPlatformContext,
  ActionFactoryWithPlatformContext,
  EditAction,
  ContributedPlatformActionsDict,
  ContributedEditActionsDict,
  isCustomManifestAction,
};
